export enum EClientEventName {
    SESSION = "session",
    ERROR = "error",
    CALL_RING = "call.ring",
    CALL_OFFER = "call.offer",
    CALL_OFFERED = "call.offered",
    CALL_CREATED = "call.created",
    CALL_STARTED = "call.started",
    CALL_ANSWERED = "call.answered",
    CALL_ENDED = "call.ended",
    CALL_CANCELED = "call.canceled",
    CALL_HELD = "call.held",
    CALL_UNHELD = "call.unheld",
    CALL_TRANSFERRED = "call.transferred",
    CALL_MUTE = "call.mute",
    AGENT_STATE = "agent.state",
    AGENT_STATE_FORCED = "agent.state.forced",
    AGENT_CREATED = "agent.created",
    AGENT_UPDATED = "agent.updated",
    AGENT_DELETED = "agent.deleted",
    RECONNECTED = "reconnected",
    CONTACT_CREATED = "contact.created",
    CONTACT_UPDATED = "contact.updated",
    CONTACT_DELETED = "contact.deleted",
    TEAM_CREATED = "team.created",
    TEAM_UPDATED = "team.updated",
    TEAM_DELETED = "team.deleted",
    TEAM_ASSIGNED = "team.assigned",
    TEAM_UNASSIGNED = "team.unassigned",
    CONNECTION_STATE = "connection.state",
    CALL_RECORDING_READY = "call.recording.ready",
    MESSAGE_RECEIVED = "message.received",
    MESSAGE_SENT = "message.sent",
    MESSAGE_UPDATED = "message.updated",
    CONVERSATION_UPDATED = "conversation.updated",
}